import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import { Card, Col, Row } from "react-bootstrap";
import i18next from 'i18next';
import { IconButton, TooltipHost } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import './style.css'
import HEADER_TOOLBAR from '../HEADER_TOOLBAR';

function ELEMENT_CONTRACT_SEGMENT(props) {
  const { t } = useTranslation();

  const { 
    inputParam_HideHeader = false,
    inputParam_HideCarteras = false,
    inputParam_ComponentContent = null,
    inputParam_UseFake = false,
    inputParam_BoardStructure = null,
    inputParam_Container = null
} = props;

const [selectedBarIndex, setSelectedBarIndex] = useState(null);
  const fakeComponentContent = [
    { total: '--', name: t('data-lang-lbl-estrategical') },
    { total: '--', name: t('data-lang-lbl-critical') },
    { total: '--', name: t('data-lang-lbl-operational') },
    { total: '--', name: t('data-lang-lbl-minor') }
  ];
  
  const totalContract = !inputParam_UseFake ? inputParam_ComponentContent?.item?.l_segments?.reduce((acc, curr) => acc + curr.total, 0) ?? '--' : '--'
  const totalSegments = !inputParam_UseFake ? inputParam_ComponentContent?.item?.l_segments?.length ?? 0 : 0

  const [state, setState] = useState({
    series: [
      {
        name: "",
        data: inputParam_ComponentContent?.item?.l_segments?.map((_, i) => 200 * (i + 1)) ?? [],
      },
    ],
    options: {
      chart: {
        type: 'bar',
        height: '100%',
        events: {
          click: function(event, chartContext, config) {
          }
        }
      },
      tooltip: {
        enabled: false,
      },
      plotOptions: {
        bar: {
          borderRadius: 0,
          horizontal: true,
          distributed: true,
          barHeight: '80%',
          isFunnel: true,
        },
      },
      colors: [
        '#C0504E',
        '#BD9B53',
        '#9BBB58',
        '#4784bd',
      ],
      dataLabels: {
        enabled: true,
        formatter: function (val, opt) {
          return opt.w.globals.labels[opt.dataPointIndex] 
        },
        dropShadow: {
          enabled: false,
        },
      },
      xaxis: {
        categories: inputParam_ComponentContent?.item?.l_segments?.map(x => x.segmentCode) ?? [],
        labels: {
          style: {
            fontSize: '28px',
          },
        },
      },
      legend: {
        show: false,
      },
    },
    style_value_parent: {backgroundColor: "#efefef"},
    style_value: {fontSize: "18px"},
    style_text: {fontSize: "13px", backgroundColor: "#efefef"}
  });

  useEffect(() => {
    const xAxisLabels = document.querySelectorAll('.apexcharts-data-labels text');
    xAxisLabels.forEach(label => {
      label.style.fontSize = '16px';
    });
  }, []);


  useEffect(() => {
    const bars = document.querySelectorAll('.apexcharts-bar-series .apexcharts-bar-area');

    const handleBarClick = (event) => {
      const barIndex = Array.from(event.currentTarget.parentNode.children).indexOf(event.currentTarget)
      
      setSelectedBarIndex(barIndex);
    };

    bars.forEach(bar => {
      bar.addEventListener('click', handleBarClick);
    });

    return () => {
      bars.forEach(bar => {
        bar.removeEventListener('click', handleBarClick);
      });
    };
  }, []);

  const renderContent = () => {
    return  <Row className='h-100' style={{opacity: inputParam_UseFake ? ".4" : ""}}>
              <Row className='h-80'>
                <Col xl={8} className='h-100'>
                  <div style={{position: "absolute",float: "left",top: "50px",left: "-10px"}}>
                    <Row>
                      <Col xl={12} className='text-center' style={{fontSize: "25px",fontWeight: "bold"}}>{inputParam_ComponentContent?.item !== null ? (totalContract) : '--'}</Col>
                      <Col xl={12} className='text-center' style={{fontSize: "14px",fontWeight: "bold"}}>{t('data-lang-lbl-contracts')}</Col>
                    </Row>
                  </div>
                  <ReactApexChart options={state.options} series={state.series} type="bar" height='100%' />
                </Col>
                <Col xl={4} className='py-0 my-auto h-100'>
                  <Row style={{height: (totalSegments === 3 ? "10%" : "13%")}} />
                  {
                    !inputParam_UseFake && inputParam_ComponentContent.item && inputParam_ComponentContent.item.l_segments.map((segment, index) => 
                      <Row key={index} className="border-bottom" style={{height: (totalSegments === 3 ? "27%" : "20%"), backgroundColor: index === selectedBarIndex ? "#efefef" : ""}}>
                        <Col className={`pyramid-value-${totalSegments}`} xl={12}>{segment.total}</Col>
                        <Col className={`pyramid-text-${totalSegments}`} xl={12}>{segment.name}</Col>
                      </Row>  
                    )
                  }  
                  {
                    inputParam_UseFake && fakeComponentContent.map((segment, index) => 
                      <Row key={index} className="border-bottom" style={{height: (totalSegments === 3 ? "27%" : "20%"), backgroundColor: index === selectedBarIndex ? "#efefef" : ""}}>
                        <Col className={`pyramid-value-${totalSegments}`} xl={12}>{segment.total}</Col>
                        <Col className={`pyramid-text-${totalSegments}`} xl={12}>{segment.name}</Col>
                      </Row>  
                    )
                  }       
                </Col>
              </Row>
              {
                !inputParam_HideCarteras &&
                <Col className='p-0 mx-0 mb-auto m-0 h-20'>
                  <Row className='m-1'>
                    <Col>
                      <Row>
                        {
                          inputParam_ComponentContent?.item?.l_currency.map((currency, index) => 
                            index <= 1 ?
                            <Col key={index} className='border mx-1'>
                              <Row className='text-center' style={state.style_value_parent}><Col style={state.style_value}>{parseInt(currency.total.toFixed(0)).toLocaleString(i18next.language)}</Col></Row>
                              <Row className='border-top' style={state.style_text}>
                                <Col className='pe-0 me-0'>{t('data-lang-lbl-portfolioamount')}</Col>
                                <Col className='col-auto ms-auto ps-0 ms-0'>{currency.name}</Col>
                              </Row>
                            </Col> : undefined
                          )
                        }
                      </Row>
                    </Col>
                    <Col className='col-auto me-auto px-0'>
                      <TooltipHost
                          content={
                            <Row>
                              <Col>
                              {
                                inputParam_ComponentContent?.item?.l_currency.map((currency, index) => 
                                <Row key={index} className='my-1'>
                                  <Col className='border mx-1'>
                                    <Row className='text-center' style={state.style_value_parent}><Col style={state.style_value}>{parseInt(currency.total.toFixed(0)).toLocaleString(i18next.language)}</Col></Row>
                                    <Row className='border-top' style={state.style_text}>
                                      <Col className='pe-0 me-0'>{t('data-lang-lbl-portfolioamount')}</Col>
                                      <Col className='col-auto ms-auto ps-0 ms-0'>{currency.name}</Col>
                                    </Row>
                                  </Col>
                                </Row>)
                              }
                              </Col>
                            </Row>
                          }
                          id="miTooltip"
                          calloutProps={{ gapSpace: 0 }}
                      >
                        <IconButton className='border' iconProps={{iconName: "View"}} />
                      </TooltipHost>
                    </Col>
                  </Row>
                </Col>
              }
            </Row>
  }

  return  (
          <>
            {
              !inputParam_UseFake &&
              <Card className='h-100'>
                {
                  !inputParam_HideHeader &&
                  <Card.Header className="card-header-compact">
                    <Card.Title className="d-flex justify-content-between">
                      <b>{(!inputParam_UseFake && inputParam_ComponentContent !== null) ? (inputParam_ComponentContent.boardComponentTitle ?? t('data-lang-boxname-contractsegments')) : t('data-lang-boxname-contractsegments')}</b>
                      <div className='toolbar d-flex'>
                        <HEADER_TOOLBAR
                          inputParam_BoardStructure={inputParam_BoardStructure}
                          inputParam_Container={inputParam_Container}
                        />
                      </div>
                    </Card.Title>
                  </Card.Header>
                }
                <Card.Body className='h-100 pb-0'>
                  { renderContent() }
                </Card.Body>
              </Card>
            }
            {
              inputParam_UseFake && renderContent()
            }
          </>
          );
}

ELEMENT_CONTRACT_SEGMENT.propTypes = {
  inputParam_HideHeader: PropTypes.bool.isRequired,
  inputParam_HideCarteras: PropTypes.bool,
  inputParam_ComponentContent: PropTypes.object.isRequired,
};

export default ELEMENT_CONTRACT_SEGMENT;